module.exports = __webpack_public_path__ + "static/media/onboarding_push_dialog_finger.c046d4aa.png";